import {
  FormValues,
  TerminWiederholungsIntervall,
  TerminWochentage,
  UpdateFormValueInput,
  WOCHENTAGE,
} from '@/domain/termine/shared/types';
import dayjs from 'dayjs';

export function getFixedWeekday(date: dayjs.Dayjs) {
  const currentDay = date.day();
  const mondayFirstIndex = currentDay === 0 ? 6 : currentDay - 1;
  return WOCHENTAGE[mondayFirstIndex].value;
}

export function getWeekdaySelection<
  T extends FormValues | UpdateFormValueInput,
>(data: T): TerminWochentage[] {
  const selectedDays = data.wochentagAuswahl || [];

  if (data.wiederholungsIntervall !== TerminWiederholungsIntervall.WOCHE) {
    return selectedDays;
  }

  const fixedWeekday = getFixedWeekday(dayjs(data.datum));
  return [...new Set([fixedWeekday, ...selectedDays])];
}
